const MIN_HOURS_TO_CANCEL_SURGERY = 48;

export {MIN_HOURS_TO_CANCEL_SURGERY};
